module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Cyril O’Brien is a retired London Fire Brigade Borough Commander, who since leaving the LFB has moved in the world of Emergency Planning, and is currently working for the London Borough of Bexley.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Upon his retirement, finding additional time on his hands, Cyril made a foray into trying to write a book. His first effort being successful, prompted him to set about this edition as his number two.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("He is married to Jackie and they have three very talented children, Georgina, Anne-Marie and Spencer. They have also been graced with three grandchildren, Coray, Anaya and Kaylan.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0